var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListChecksreact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12 12h8.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 6h8.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 18h8.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.625 4.5-3.25313 3-1.62187-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.625 10.5-3.25313 3-1.62187-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.625 16.5-3.25313 3-1.62187-1.5"
  }))));
}
export default SvgListChecksreact;